/** Icon Names available for Gtk Applications */
export enum IconName {
  AccessoriesCalculator = "accessories-calculator",
  AccessoriesCalculatorSymbolic = "accessories-calculator-symbolic",
  AccessoriesCharacterMap = "accessories-character-map",
  AccessoriesCharacterMapSymbolic = "accessories-character-map-symbolic",
  AccessoriesDictionary = "accessories-dictionary",
  AccessoriesDictionarySymbolic = "accessories-dictionary-symbolic",
  AccessoriesTextEditor = "accessories-text-editor",
  ActionUnavailable = "action-unavailable",
  ActionUnavailableSymbolic = "action-unavailable-symbolic",
  AddressBookNew = "address-book-new",
  AddressBookNewSymbolic = "address-book-new-symbolic",
  AirplaneMode = "airplane-mode",
  AirplaneModeSymbolic = "airplane-mode-symbolic",
  Alarm = "alarm",
  ApplicationCertificate = "application-certificate",
  ApplicationExit = "application-exit",
  ApplicationExitSymbolic = "application-exit-symbolic",
  ApplicationRssXml = "application-rss+xml",
  ApplicationRssxmlSymbolic = "application-rss+xml-symbolic",
  ApplicationsAccessories = "applications-accessories",
  ApplicationsDevelopment = "applications-development",
  ApplicationsEngineering = "applications-engineering",
  ApplicationsEngineeringSymbolic = "applications-engineering-symbolic",
  ApplicationsGames = "applications-games",
  ApplicationsGamesSymbolic = "applications-games-symbolic",
  ApplicationsGraphics = "applications-graphics",
  ApplicationsGraphicsSymbolic = "applications-graphics-symbolic",
  ApplicationsInternet = "applications-internet",
  ApplicationsMultimedia = "applications-multimedia",
  ApplicationsMultimediaSymbolic = "applications-multimedia-symbolic",
  ApplicationsOffice = "applications-office",
  ApplicationsOther = "applications-other",
  ApplicationsScience = "applications-science",
  ApplicationsScienceSymbolic = "applications-science-symbolic",
  ApplicationsSystem = "applications-system",
  ApplicationsSystemSymbolic = "applications-system-symbolic",
  ApplicationsUtilities = "applications-utilities",
  ApplicationsUtilitiesSymbolic = "applications-utilities-symbolic",
  ApplicationXAddon = "application-x-addon",
  ApplicationXAddonSymbolic = "application-x-addon-symbolic",
  ApplicationXAppliance = "application-x-appliance",
  ApplicationXApplianceSymbolic = "application-x-appliance-symbolic",
  ApplicationXExecutable = "application-x-executable",
  ApplicationXExecutableSymbolic = "application-x-executable-symbolic",
  AppointmentMissed = "appointment-missed",
  AppointmentNew = "appointment-new",
  AppointmentNewSymbolic = "appointment-new-symbolic",
  AppointmentSoon = "appointment-soon",
  AudioCard = "audio-card",
  AudioHeadphones = "audio-headphones",
  AudioHeadset = "audio-headset",
  AudioInputMicrophone = "audio-input-microphone",
  AudioSpeakers = "audio-speakers",
  AudioVolumeHigh = "audio-volume-high",
  AudioVolumeLow = "audio-volume-low",
  AudioVolumeMedium = "audio-volume-medium",
  AudioVolumeMuted = "audio-volume-muted",
  AudioXGeneric = "audio-x-generic",
  AudioXGenericSymbolic = "audio-x-generic-symbolic",
  AvatarDefault = "avatar-default",
  AvatarDefaultSymbolic = "avatar-default-symbolic",
  Battery = "battery",
  BatteryCaution = "battery-caution",
  BatteryCautionCharging = "battery-caution-charging",
  BatteryCautionChargingSymbolic = "battery-caution-charging-symbolic",
  BatteryCautionSymbolic = "battery-caution-symbolic",
  BatteryEmpty = "battery-empty",
  BatteryEmptyCharging = "battery-empty-charging",
  BatteryEmptyChargingSymbolic = "battery-empty-charging-symbolic",
  BatteryEmptySymbolic = "battery-empty-symbolic",
  BatteryFull = "battery-full",
  BatteryFullCharged = "battery-full-charged",
  BatteryFullChargedSymbolic = "battery-full-charged-symbolic",
  BatteryFullCharging = "battery-full-charging",
  BatteryFullChargingSymbolic = "battery-full-charging-symbolic",
  BatteryFullSymbolic = "battery-full-symbolic",
  BatteryGood = "battery-good",
  BatteryGoodCharging = "battery-good-charging",
  BatteryGoodChargingSymbolic = "battery-good-charging-symbolic",
  BatteryGoodSymbolic = "battery-good-symbolic",
  BatteryLow = "battery-low",
  BatteryLowCharging = "battery-low-charging",
  BatteryLowChargingSymbolic = "battery-low-charging-symbolic",
  BatteryLowSymbolic = "battery-low-symbolic",
  BatteryMissing = "battery-missing",
  BatteryMissingSymbolic = "battery-missing-symbolic",
  BatterySymbolic = "battery-symbolic",
  BluetoothActive = "bluetooth-active",
  BluetoothActiveSymbolic = "bluetooth-active-symbolic",
  BluetoothDisabled = "bluetooth-disabled",
  BluetoothDisabledSymbolic = "bluetooth-disabled-symbolic",
  BookmarkNew = "bookmark-new",
  BookmarkNewSymbolic = "bookmark-new-symbolic",
  CallMissed = "call-missed",
  CallStart = "call-start",
  CallStop = "call-stop",
  CameraPhoto = "camera-photo",
  CameraVideo = "camera-video",
  CameraWeb = "camera-web",
  ChangesAllow = "changes-allow",
  ChangesAllowSymbolic = "changes-allow-symbolic",
  ChangesPrevent = "changes-prevent",
  ChangesPreventSymbolic = "changes-prevent-symbolic",
  ChannelInsecure = "channel-insecure",
  ChannelInsecureSymbolic = "channel-insecure-symbolic",
  ChannelSecure = "channel-secure",
  ChannelSecureSymbolic = "channel-secure-symbolic",
  ColorimeterColorhug = "colorimeter-colorhug",
  ColorimeterColorhugSymbolic = "colorimeter-colorhug-symbolic",
  Computer = "computer",
  ComputerAppleIpad = "computer-apple-ipad",
  ComputerAppleIpadSymbolic = "computer-apple-ipad-symbolic",
  ComputerFail = "computer-fail",
  ComputerFailSymbolic = "computer-fail-symbolic",
  ContactNew = "contact-new",
  ContactNewSymbolic = "contact-new-symbolic",
  ContentLoading = "content-loading",
  ContentLoadingSymbolic = "content-loading-symbolic",
  DaytimeSunrise = "daytime-sunrise",
  DaytimeSunriseSymbolic = "daytime-sunrise-symbolic",
  DaytimeSunset = "daytime-sunset",
  DaytimeSunsetSymbolic = "daytime-sunset-symbolic",
  DialogError = "dialog-error",
  DialogErrorSymbolic = "dialog-error-symbolic",
  DialogInformation = "dialog-information",
  DialogInformationSymbolic = "dialog-information-symbolic",
  DialogPassword = "dialog-password",
  DialogPasswordSymbolic = "dialog-password-symbolic",
  DialogQuestion = "dialog-question",
  DialogQuestionSymbolic = "dialog-question-symbolic",
  DialogWarning = "dialog-warning",
  DialogWarningSymbolic = "dialog-warning-symbolic",
  DisplayBrightness = "display-brightness",
  DisplayBrightnessSymbolic = "display-brightness-symbolic",
  DisplayProjector = "display-projector",
  DocumentEdit = "document-edit",
  DocumentNew = "document-new",
  DocumentOpen = "document-open",
  DocumentOpenRecent = "document-open-recent",
  DocumentPageSetup = "document-page-setup",
  DocumentPrint = "document-print",
  DocumentPrintPreview = "document-print-preview",
  DocumentPrintPreviewSymbolic = "document-print-preview-symbolic",
  DocumentPrintSymbolic = "document-print-symbolic",
  DocumentProperties = "document-properties",
  DocumentRevert = "document-revert",
  DocumentRevertSymbolic = "document-revert-symbolic",
  DocumentSave = "document-save",
  DocumentSaveAs = "document-save-as",
  DocumentSend = "document-send",
  DriveHarddisk = "drive-harddisk",
  DriveHarddiskIeee1394 = "drive-harddisk-ieee1394",
  DriveHarddiskIeee1394Symbolic = "drive-harddisk-ieee1394-symbolic",
  DriveHarddiskSymbolic = "drive-harddisk-symbolic",
  DriveHarddiskSystem = "drive-harddisk-system",
  DriveHarddiskSystemSymbolic = "drive-harddisk-system-symbolic",
  DriveMultidisk = "drive-multidisk",
  DriveMultidiskSymbolic = "drive-multidisk-symbolic",
  DriveOptical = "drive-optical",
  DriveRemovableMedia = "drive-removable-media",
  EditClear = "edit-clear",
  EditClearAll = "edit-clear-all",
  EditCopy = "edit-copy",
  EditCut = "edit-cut",
  EditDelete = "edit-delete",
  EditFind = "edit-find",
  EditFindReplace = "edit-find-replace",
  EditFindSymbolic = "edit-find-symbolic",
  EditPaste = "edit-paste",
  EditRedo = "edit-redo",
  EditSelect = "edit-select",
  EditSelectAll = "edit-select-all",
  EditUndo = "edit-undo",
  EmblemDefault = "emblem-default",
  EmblemDefaultSymbolic = "emblem-default-symbolic",
  EmblemDocuments = "emblem-documents",
  EmblemDocumentsSymbolic = "emblem-documents-symbolic",
  EmblemDownloads = "emblem-downloads",
  EmblemFavorite = "emblem-favorite",
  EmblemFavoriteSymbolic = "emblem-favorite-symbolic",
  EmblemGeneric = "emblem-generic",
  EmblemImportant = "emblem-important",
  EmblemImportantSymbolic = "emblem-important-symbolic",
  EmblemMail = "emblem-mail",
  EmblemNew = "emblem-new",
  EmblemOk = "emblem-ok",
  EmblemOkSymbolic = "emblem-ok-symbolic",
  EmblemPackage = "emblem-package",
  EmblemPhotos = "emblem-photos",
  EmblemPhotosSymbolic = "emblem-photos-symbolic",
  EmblemReadonly = "emblem-readonly",
  EmblemShared = "emblem-shared",
  EmblemSharedSymbolic = "emblem-shared-symbolic",
  EmblemSymbolicLink = "emblem-symbolic-link",
  EmblemSynchronized = "emblem-synchronized",
  EmblemSynchronizing = "emblem-synchronizing",
  EmblemSynchronizingSymbolic = "emblem-synchronizing-symbolic",
  EmblemSystem = "emblem-system",
  EmblemSystemSymbolic = "emblem-system-symbolic",
  EmblemUnreadable = "emblem-unreadable",
  EmblemUrgent = "emblem-urgent",
  EmblemVideos = "emblem-videos",
  EmblemVideosSymbolic = "emblem-videos-symbolic",
  EmblemWeb = "emblem-web",
  ErrorCorrect = "error-correct",
  FaceAngel = "face-angel",
  FaceAngelSymbolic = "face-angel-symbolic",
  FaceAngry = "face-angry",
  FaceAngrySymbolic = "face-angry-symbolic",
  FaceCool = "face-cool",
  FaceCoolSymbolic = "face-cool-symbolic",
  FaceCrying = "face-crying",
  FaceCryingSymbolic = "face-crying-symbolic",
  FaceDevilish = "face-devilish",
  FaceDevilishSymbolic = "face-devilish-symbolic",
  FaceEmbarrassed = "face-embarrassed",
  FaceEmbarrassedSymbolic = "face-embarrassed-symbolic",
  FaceKiss = "face-kiss",
  FaceKissSymbolic = "face-kiss-symbolic",
  FaceLaugh = "face-laugh",
  FaceLaughSymbolic = "face-laugh-symbolic",
  FaceMonkey = "face-monkey",
  FaceMonkeySymbolic = "face-monkey-symbolic",
  FacePlain = "face-plain",
  FacePlainSymbolic = "face-plain-symbolic",
  FaceRaspberry = "face-raspberry",
  FaceRaspberrySymbolic = "face-raspberry-symbolic",
  FaceSad = "face-sad",
  FaceSadSymbolic = "face-sad-symbolic",
  FaceShutmouth = "face-shutmouth",
  FaceShutmouthSymbolic = "face-shutmouth-symbolic",
  FaceSick = "face-sick",
  FaceSickSymbolic = "face-sick-symbolic",
  FaceSmile = "face-smile",
  FaceSmileBig = "face-smile-big",
  FaceSmileBigSymbolic = "face-smile-big-symbolic",
  FaceSmileSymbolic = "face-smile-symbolic",
  FaceSmirk = "face-smirk",
  FaceSmirkSymbolic = "face-smirk-symbolic",
  FaceSurprise = "face-surprise",
  FaceSurpriseSymbolic = "face-surprise-symbolic",
  FaceTired = "face-tired",
  FaceTiredSymbolic = "face-tired-symbolic",
  FaceUncertain = "face-uncertain",
  FaceUncertainSymbolic = "face-uncertain-symbolic",
  FaceWink = "face-wink",
  FaceWinkSymbolic = "face-wink-symbolic",
  FaceWorried = "face-worried",
  FaceWorriedSymbolic = "face-worried-symbolic",
  FaceYawn = "face-yawn",
  FaceYawnSymbolic = "face-yawn-symbolic",
  FindLocation = "find-location",
  FindLocationSymbolic = "find-location-symbolic",
  Folder = "folder",
  FolderDocuments = "folder-documents",
  FolderDocumentsSymbolic = "folder-documents-symbolic",
  FolderDownload = "folder-download",
  FolderDownloadSymbolic = "folder-download-symbolic",
  FolderDragAccept = "folder-drag-accept",
  FolderDragAcceptSymbolic = "folder-drag-accept-symbolic",
  FolderMusic = "folder-music",
  FolderMusicSymbolic = "folder-music-symbolic",
  FolderNew = "folder-new",
  FolderNewSymbolic = "folder-new-symbolic",
  FolderOpen = "folder-open",
  FolderOpenSymbolic = "folder-open-symbolic",
  FolderPictures = "folder-pictures",
  FolderPicturesSymbolic = "folder-pictures-symbolic",
  FolderPublicshare = "folder-publicshare",
  FolderPublicshareSymbolic = "folder-publicshare-symbolic",
  FolderRemote = "folder-remote",
  FolderRemoteSymbolic = "folder-remote-symbolic",
  FolderSavedSearch = "folder-saved-search",
  FolderSavedSearchSymbolic = "folder-saved-search-symbolic",
  FolderSymbolic = "folder-symbolic",
  FolderTemplates = "folder-templates",
  FolderTemplatesSymbolic = "folder-templates-symbolic",
  FolderVideos = "folder-videos",
  FolderVideosSymbolic = "folder-videos-symbolic",
  FolderVisiting = "folder-visiting",
  FolderVisitingSymbolic = "folder-visiting-symbolic",
  FontXGeneric = "font-x-generic",
  FontXGenericSymbolic = "font-x-generic-symbolic",
  FormatIndentLess = "format-indent-less",
  FormatIndentMore = "format-indent-more",
  FormatJustifyCenter = "format-justify-center",
  FormatJustifyFill = "format-justify-fill",
  FormatJustifyLeft = "format-justify-left",
  FormatJustifyRight = "format-justify-right",
  FormatTextBold = "format-text-bold",
  FormatTextDirectionLtr = "format-text-direction-ltr",
  FormatTextDirectionRtl = "format-text-direction-rtl",
  FormatTextItalic = "format-text-italic",
  FormatTextStrikethrough = "format-text-strikethrough",
  FormatTextUnderline = "format-text-underline",
  GoBottom = "go-bottom",
  GoDown = "go-down",
  GoFirst = "go-first",
  GoHome = "go-home",
  GoJump = "go-jump",
  GoLast = "go-last",
  GoNext = "go-next",
  GoPrevious = "go-previous",
  GoTop = "go-top",
  GoUp = "go-up",
  HelpAbout = "help-about",
  HelpAboutSymbolic = "help-about-symbolic",
  HelpBrowser = "help-browser",
  HelpBrowserSymbolic = "help-browser-symbolic",
  HelpContents = "help-contents",
  HelpContentsSymbolic = "help-contents-symbolic",
  HelpFaq = "help-faq",
  HelpFaqSymbolic = "help-faq-symbolic",
  ImageLoading = "image-loading",
  ImageLoadingSymbolic = "image-loading-symbolic",
  ImageMissing = "image-missing",
  ImageMissingSymbolic = "image-missing-symbolic",
  ImageXGeneric = "image-x-generic",
  ImageXGenericSymbolic = "image-x-generic-symbolic",
  InputDialpad = "input-dialpad",
  InputGaming = "input-gaming",
  InputKeyboard = "input-keyboard",
  InputMouse = "input-mouse",
  InputTablet = "input-tablet",
  InputTouchpad = "input-touchpad",
  InsertImage = "insert-image",
  InsertLink = "insert-link",
  InsertObject = "insert-object",
  InsertText = "insert-text",
  KeyboardBrightness = "keyboard-brightness",
  KeyboardBrightnessSymbolic = "keyboard-brightness-symbolic",
  ListAdd = "list-add",
  ListAddSymbolic = "list-add-symbolic",
  ListRemove = "list-remove",
  ListRemoveAll = "list-remove-all",
  ListRemoveAllSymbolic = "list-remove-all-symbolic",
  ListRemoveSymbolic = "list-remove-symbolic",
  MailAttachment = "mail-attachment",
  MailForward = "mail-forward",
  MailForwardSymbolic = "mail-forward-symbolic",
  MailMarkImportant = "mail-mark-important",
  MailMarkJunk = "mail-mark-junk",
  MailMarkJunkSymbolic = "mail-mark-junk-symbolic",
  MailMarkNotjunk = "mail-mark-notjunk",
  MailMarkNotjunkSymbolic = "mail-mark-notjunk-symbolic",
  MailMarkRead = "mail-mark-read",
  MailMarkReadSymbolic = "mail-mark-read-symbolic",
  MailMarkUnread = "mail-mark-unread",
  MailMarkUnreadSymbolic = "mail-mark-unread-symbolic",
  MailMessageNew = "mail-message-new",
  MailMessageNewSymbolic = "mail-message-new-symbolic",
  MailRead = "mail-read",
  MailReplied = "mail-replied",
  MailReplyAll = "mail-reply-all",
  MailReplyAllSymbolic = "mail-reply-all-symbolic",
  MailReplySender = "mail-reply-sender",
  MailReplySenderSymbolic = "mail-reply-sender-symbolic",
  MailSend = "mail-send",
  MailSendReceive = "mail-send-receive",
  MailSigned = "mail-signed",
  MailSignedVerified = "mail-signed-verified",
  MailUnread = "mail-unread",
  MarkLocation = "mark-location",
  MarkLocationSymbolic = "mark-location-symbolic",
  MediaEject = "media-eject",
  MediaFlash = "media-flash",
  MediaFloppy = "media-floppy",
  MediaOptical = "media-optical",
  MediaOpticalBd = "media-optical-bd",
  MediaOpticalBdSymbolic = "media-optical-bd-symbolic",
  MediaOpticalCdAudio = "media-optical-cd-audio",
  MediaOpticalCdAudioSymbolic = "media-optical-cd-audio-symbolic",
  MediaOpticalDvd = "media-optical-dvd",
  MediaOpticalDvdSymbolic = "media-optical-dvd-symbolic",
  MediaPlaybackPause = "media-playback-pause",
  MediaPlaybackStart = "media-playback-start",
  MediaPlaybackStop = "media-playback-stop",
  MediaPlaylistConsecutive = "media-playlist-consecutive",
  MediaPlaylistRepeat = "media-playlist-repeat",
  MediaPlaylistRepeatSong = "media-playlist-repeat-song",
  MediaPlaylistShuffle = "media-playlist-shuffle",
  MediaRecord = "media-record",
  MediaRemovable = "media-removable",
  MediaSeekBackward = "media-seek-backward",
  MediaSeekForward = "media-seek-forward",
  MediaSkipBackward = "media-skip-backward",
  MediaSkipForward = "media-skip-forward",
  MediaTape = "media-tape",
  MediaTapeSymbolic = "media-tape-symbolic",
  MediaViewSubtitles = "media-view-subtitles",
  MediaZip = "media-zip",
  MediaZipSymbolic = "media-zip-symbolic",
  MicrophoneSensitivityHigh = "microphone-sensitivity-high",
  MicrophoneSensitivityLow = "microphone-sensitivity-low",
  MicrophoneSensitivityMedium = "microphone-sensitivity-medium",
  MicrophoneSensitivityMuted = "microphone-sensitivity-muted",
  Modem = "modem",
  ModemSymbolic = "modem-symbolic",
  MultimediaPlayer = "multimedia-player",
  MultimediaPlayerAppleIpodTouch = "multimedia-player-apple-ipod-touch",
  MultimediaPlayerAppleIpodTouchSymbolic = "multimedia-player-apple-ipod-touch-symbolic",
  MultimediaVolumeControl = "multimedia-volume-control",
  MultimediaVolumeControlSymbolic = "multimedia-volume-control-symbolic",
  NetworkCellular3g = "network-cellular-3g",
  NetworkCellular3gSymbolic = "network-cellular-3g-symbolic",
  NetworkCellular4g = "network-cellular-4g",
  NetworkCellular4gSymbolic = "network-cellular-4g-symbolic",
  NetworkCellularAcquiring = "network-cellular-acquiring",
  NetworkCellularAcquiringSymbolic = "network-cellular-acquiring-symbolic",
  NetworkCellularConnected = "network-cellular-connected",
  NetworkCellularConnectedSymbolic = "network-cellular-connected-symbolic",
  NetworkCellularEdge = "network-cellular-edge",
  NetworkCellularEdgeSymbolic = "network-cellular-edge-symbolic",
  NetworkCellularGprs = "network-cellular-gprs",
  NetworkCellularGprsSymbolic = "network-cellular-gprs-symbolic",
  NetworkCellularNoRoute = "network-cellular-no-route",
  NetworkCellularNoRouteSymbolic = "network-cellular-no-route-symbolic",
  NetworkCellularOffline = "network-cellular-offline",
  NetworkCellularOfflineSymbolic = "network-cellular-offline-symbolic",
  NetworkCellularSignalExcellent = "network-cellular-signal-excellent",
  NetworkCellularSignalExcellentSymbolic = "network-cellular-signal-excellent-symbolic",
  NetworkCellularSignalGood = "network-cellular-signal-good",
  NetworkCellularSignalGoodSymbolic = "network-cellular-signal-good-symbolic",
  NetworkCellularSignalNone = "network-cellular-signal-none",
  NetworkCellularSignalNoneSymbolic = "network-cellular-signal-none-symbolic",
  NetworkCellularSignalOk = "network-cellular-signal-ok",
  NetworkCellularSignalOkSymbolic = "network-cellular-signal-ok-symbolic",
  NetworkCellularSignalWeak = "network-cellular-signal-weak",
  NetworkCellularSignalWeakSymbolic = "network-cellular-signal-weak-symbolic",
  NetworkCellularUmts = "network-cellular-umts",
  NetworkCellularUmtsSymbolic = "network-cellular-umts-symbolic",
  NetworkError = "network-error",
  NetworkIdle = "network-idle",
  NetworkOffline = "network-offline",
  NetworkReceive = "network-receive",
  NetworkServer = "network-server",
  NetworkServerSymbolic = "network-server-symbolic",
  NetworkTransmit = "network-transmit",
  NetworkTransmitReceive = "network-transmit-receive",
  NetworkVpn = "network-vpn",
  NetworkVpnAcquiring = "network-vpn-acquiring",
  NetworkVpnAcquiringSymbolic = "network-vpn-acquiring-symbolic",
  NetworkVpnSymbolic = "network-vpn-symbolic",
  NetworkWired = "network-wired",
  NetworkWiredAcquiring = "network-wired-acquiring",
  NetworkWiredAcquiringSymbolic = "network-wired-acquiring-symbolic",
  NetworkWiredDisconnected = "network-wired-disconnected",
  NetworkWiredDisconnectedSymbolic = "network-wired-disconnected-symbolic",
  NetworkWiredNoRoute = "network-wired-no-route",
  NetworkWiredNoRouteSymbolic = "network-wired-no-route-symbolic",
  NetworkWiredOffline = "network-wired-offline",
  NetworkWiredOfflineSymbolic = "network-wired-offline-symbolic",
  NetworkWireless = "network-wireless",
  NetworkWirelessAcquiring = "network-wireless-acquiring",
  NetworkWirelessAcquiringSymbolic = "network-wireless-acquiring-symbolic",
  NetworkWirelessConnected = "network-wireless-connected",
  NetworkWirelessConnectedSymbolic = "network-wireless-connected-symbolic",
  NetworkWirelessEncrypted = "network-wireless-encrypted",
  NetworkWirelessEncryptedSymbolic = "network-wireless-encrypted-symbolic",
  NetworkWirelessHotspot = "network-wireless-hotspot",
  NetworkWirelessHotspotSymbolic = "network-wireless-hotspot-symbolic",
  NetworkWirelessNoRoute = "network-wireless-no-route",
  NetworkWirelessNoRouteSymbolic = "network-wireless-no-route-symbolic",
  NetworkWirelessOffline = "network-wireless-offline",
  NetworkWirelessOfflineSymbolic = "network-wireless-offline-symbolic",
  NetworkWirelessSignalExcellent = "network-wireless-signal-excellent",
  NetworkWirelessSignalExcellentSymbolic = "network-wireless-signal-excellent-symbolic",
  NetworkWirelessSignalGood = "network-wireless-signal-good",
  NetworkWirelessSignalGoodSymbolic = "network-wireless-signal-good-symbolic",
  NetworkWirelessSignalNone = "network-wireless-signal-none",
  NetworkWirelessSignalNoneSymbolic = "network-wireless-signal-none-symbolic",
  NetworkWirelessSignalOk = "network-wireless-signal-ok",
  NetworkWirelessSignalOkSymbolic = "network-wireless-signal-ok-symbolic",
  NetworkWirelessSignalWeak = "network-wireless-signal-weak",
  NetworkWirelessSignalWeakSymbolic = "network-wireless-signal-weak-symbolic",
  NetworkWorkgroup = "network-workgroup",
  NetworkWorkgroupSymbolic = "network-workgroup-symbolic",
  NightLight = "night-light",
  NightLightSymbolic = "night-light-symbolic",
  NonStarred = "non-starred",
  NonStarredSymbolic = "non-starred-symbolic",
  ObjectFlipHorizontal = "object-flip-horizontal",
  ObjectFlipVertical = "object-flip-vertical",
  ObjectRotateLeft = "object-rotate-left",
  ObjectRotateRight = "object-rotate-right",
  ObjectSelect = "object-select",
  ObjectSelectSymbolic = "object-select-symbolic",
  OpenMenu = "open-menu",
  OpenMenuSymbolic = "open-menu-symbolic",
  PackageXGeneric = "package-x-generic",
  PackageXGenericSymbolic = "package-x-generic-symbolic",
  PanDown = "pan-down",
  PanDownSymbolic = "pan-down-symbolic",
  PanEnd = "pan-end",
  PanEndSymbolic = "pan-end-symbolic",
  PanStart = "pan-start",
  PanStartSymbolic = "pan-start-symbolic",
  PanUp = "pan-up",
  PanUpSymbolic = "pan-up-symbolic",
  Pda = "pda",
  PdaSymbolic = "pda-symbolic",
  Phone = "phone",
  PhoneAppleIphone = "phone-apple-iphone",
  PhoneAppleIphoneSymbolic = "phone-apple-iphone-symbolic",
  PreferencesDesktop = "preferences-desktop",
  PreferencesDesktopAccessibility = "preferences-desktop-accessibility",
  PreferencesDesktopAccessibilitySymbolic = "preferences-desktop-accessibility-symbolic",
  PreferencesDesktopDisplay = "preferences-desktop-display",
  PreferencesDesktopDisplaySymbolic = "preferences-desktop-display-symbolic",
  PreferencesDesktopFont = "preferences-desktop-font",
  PreferencesDesktopFontSymbolic = "preferences-desktop-font-symbolic",
  PreferencesDesktopKeyboard = "preferences-desktop-keyboard",
  PreferencesDesktopKeyboardShortcuts = "preferences-desktop-keyboard-shortcuts",
  PreferencesDesktopKeyboardShortcutsSymbolic = "preferences-desktop-keyboard-shortcuts-symbolic",
  PreferencesDesktopKeyboardSymbolic = "preferences-desktop-keyboard-symbolic",
  PreferencesDesktopLocale = "preferences-desktop-locale",
  PreferencesDesktopLocaleSymbolic = "preferences-desktop-locale-symbolic",
  PreferencesDesktopMultimedia = "preferences-desktop-multimedia",
  PreferencesDesktopPeripherals = "preferences-desktop-peripherals",
  PreferencesDesktopPersonal = "preferences-desktop-personal",
  PreferencesDesktopRemoteDesktop = "preferences-desktop-remote-desktop",
  PreferencesDesktopRemoteDesktopSymbolic = "preferences-desktop-remote-desktop-symbolic",
  PreferencesDesktopScreensaver = "preferences-desktop-screensaver",
  PreferencesDesktopScreensaverSymbolic = "preferences-desktop-screensaver-symbolic",
  PreferencesDesktopTheme = "preferences-desktop-theme",
  PreferencesDesktopWallpaper = "preferences-desktop-wallpaper",
  PreferencesDesktopWallpaperSymbolic = "preferences-desktop-wallpaper-symbolic",
  PreferencesOther = "preferences-other",
  PreferencesOtherSymbolic = "preferences-other-symbolic",
  PreferencesSystem = "preferences-system",
  PreferencesSystemNetwork = "preferences-system-network",
  PreferencesSystemNetworkSymbolic = "preferences-system-network-symbolic",
  PreferencesSystemPrivacy = "preferences-system-privacy",
  PreferencesSystemPrivacySymbolic = "preferences-system-privacy-symbolic",
  PreferencesSystemSymbolic = "preferences-system-symbolic",
  PreferencesSystemWindows = "preferences-system-windows",
  Printer = "printer",
  PrinterError = "printer-error",
  PrinterErrorSymbolic = "printer-error-symbolic",
  PrinterNetwork = "printer-network",
  PrinterPrinting = "printer-printing",
  PrinterPrintingSymbolic = "printer-printing-symbolic",
  PrinterWarning = "printer-warning",
  PrinterWarningSymbolic = "printer-warning-symbolic",
  ProcessStop = "process-stop",
  ProcessStopSymbolic = "process-stop-symbolic",
  RotationAllowed = "rotation-allowed",
  RotationAllowedSymbolic = "rotation-allowed-symbolic",
  RotationLocked = "rotation-locked",
  RotationLockedSymbolic = "rotation-locked-symbolic",
  Scanner = "scanner",
  SecurityHigh = "security-high",
  SecurityHighSymbolic = "security-high-symbolic",
  SecurityLow = "security-low",
  SecurityLowSymbolic = "security-low-symbolic",
  SecurityMedium = "security-medium",
  SecurityMediumSymbolic = "security-medium-symbolic",
  SemiStarred = "semi-starred",
  SemiStarredSymbolic = "semi-starred-symbolic",
  SendTo = "send-to",
  SendToSymbolic = "send-to-symbolic",
  SoftwareUpdateAvailable = "software-update-available",
  SoftwareUpdateAvailableSymbolic = "software-update-available-symbolic",
  SoftwareUpdateUrgent = "software-update-urgent",
  SoftwareUpdateUrgentSymbolic = "software-update-urgent-symbolic",
  StarNew = "star-new",
  StarNewSymbolic = "star-new-symbolic",
  Starred = "starred",
  StarredSymbolic = "starred-symbolic",
  StartHere = "start-here",
  StartHereSymbolic = "start-here-symbolic",
  SyncError = "sync-error",
  SyncSynchronizing = "sync-synchronizing",
  SystemFileManager = "system-file-manager",
  SystemFileManagerSymbolic = "system-file-manager-symbolic",
  SystemHelp = "system-help",
  SystemHelpSymbolic = "system-help-symbolic",
  SystemLockScreen = "system-lock-screen",
  SystemLockScreenSymbolic = "system-lock-screen-symbolic",
  SystemLogOut = "system-log-out",
  SystemLogOutSymbolic = "system-log-out-symbolic",
  SystemReboot = "system-reboot",
  SystemRebootSymbolic = "system-reboot-symbolic",
  SystemRun = "system-run",
  SystemRunSymbolic = "system-run-symbolic",
  SystemSearch = "system-search",
  SystemSearchSymbolic = "system-search-symbolic",
  SystemShutdown = "system-shutdown",
  SystemShutdownSymbolic = "system-shutdown-symbolic",
  SystemSoftwareInstall = "system-software-install",
  SystemSoftwareInstallSymbolic = "system-software-install-symbolic",
  SystemSoftwareUpdate = "system-software-update",
  SystemUsers = "system-users",
  SystemUsersSymbolic = "system-users-symbolic",
  TabNew = "tab-new",
  TabNewSymbolic = "tab-new-symbolic",
  TaskDue = "task-due",
  TaskPastDue = "task-past-due",
  TextHtml = "text-html",
  TextHtmlSymbolic = "text-html-symbolic",
  TextXGeneric = "text-x-generic",
  TextXGenericSymbolic = "text-x-generic-symbolic",
  TextXGenericTemplate = "text-x-generic-template",
  TextXPreview = "text-x-preview",
  TextXScript = "text-x-script",
  ToolsCheckSpelling = "tools-check-spelling",
  ToolsCheckSpellingSymbolic = "tools-check-spelling-symbolic",
  TouchpadDisabled = "touchpad-disabled",
  TouchpadDisabledSymbolic = "touchpad-disabled-symbolic",
  TrophyBronze = "trophy-bronze",
  TrophyGold = "trophy-gold",
  TrophySilver = "trophy-silver",
  UninterruptiblePowerSupply = "uninterruptible-power-supply",
  UninterruptiblePowerSupplySymbolic = "uninterruptible-power-supply-symbolic",
  UserAvailable = "user-available",
  UserAway = "user-away",
  UserBookmarks = "user-bookmarks",
  UserBookmarksSymbolic = "user-bookmarks-symbolic",
  UserBusy = "user-busy",
  UserDesktop = "user-desktop",
  UserDesktopSymbolic = "user-desktop-symbolic",
  UserHome = "user-home",
  UserHomeSymbolic = "user-home-symbolic",
  UserIdle = "user-idle",
  UserInfo = "user-info",
  UserInfoSymbolic = "user-info-symbolic",
  UserInvisible = "user-invisible",
  UserOffline = "user-offline",
  UserStatusPending = "user-status-pending",
  UserTrash = "user-trash",
  UserTrashFull = "user-trash-full",
  UserTrashFullSymbolic = "user-trash-full-symbolic",
  UserTrashSymbolic = "user-trash-symbolic",
  UtilitiesSystemMonitor = "utilities-system-monitor",
  UtilitiesSystemMonitorSymbolic = "utilities-system-monitor-symbolic",
  UtilitiesTerminal = "utilities-terminal",
  UtilitiesTerminalSymbolic = "utilities-terminal-symbolic",
  VideoDisplay = "video-display",
  VideoXGeneric = "video-x-generic",
  VideoXGenericSymbolic = "video-x-generic-symbolic",
  ViewContinuous = "view-continuous",
  ViewDual = "view-dual",
  ViewFullscreen = "view-fullscreen",
  ViewGrid = "view-grid",
  ViewList = "view-list",
  ViewMore = "view-more",
  ViewMoreSymbolic = "view-more-symbolic",
  ViewPaged = "view-paged",
  ViewPin = "view-pin",
  ViewRefresh = "view-refresh",
  ViewRefreshSymbolic = "view-refresh-symbolic",
  ViewRestore = "view-restore",
  ViewSortAscending = "view-sort-ascending",
  ViewSortAscendingSymbolic = "view-sort-ascending-symbolic",
  ViewSortDescending = "view-sort-descending",
  ViewSortDescendingSymbolic = "view-sort-descending-symbolic",
  ViewWrapped = "view-wrapped",
  WeatherClear = "weather-clear",
  WeatherClearNight = "weather-clear-night",
  WeatherFewClouds = "weather-few-clouds",
  WeatherFewCloudsNight = "weather-few-clouds-night",
  WeatherFog = "weather-fog",
  WeatherOvercast = "weather-overcast",
  WeatherSevereAlert = "weather-severe-alert",
  WeatherShowers = "weather-showers",
  WeatherShowersScattered = "weather-showers-scattered",
  WeatherSnow = "weather-snow",
  WeatherStorm = "weather-storm",
  WeatherWindy = "weather-windy",
  WindowClose = "window-close",
  WindowCloseSymbolic = "window-close-symbolic",
  WindowMaximize = "window-maximize",
  WindowMaximizeSymbolic = "window-maximize-symbolic",
  WindowMinimize = "window-minimize",
  WindowMinimizeSymbolic = "window-minimize-symbolic",
  WindowNew = "window-new",
  WindowNewSymbolic = "window-new-symbolic",
  WindowRestore = "window-restore",
  WindowRestoreSymbolic = "window-restore-symbolic",
  XOfficeAddressBook = "x-office-address-book",
  XOfficeAddressBookSymbolic = "x-office-address-book-symbolic",
  XOfficeCalendar = "x-office-calendar",
  XOfficeCalendarSymbolic = "x-office-calendar-symbolic",
  XOfficeDocument = "x-office-document",
  XOfficeDocumentSymbolic = "x-office-document-symbolic",
  XOfficeDocumentTemplate = "x-office-document-template",
  XOfficePresentation = "x-office-presentation",
  XOfficePresentationSymbolic = "x-office-presentation-symbolic",
  XOfficePresentationTemplate = "x-office-presentation-template",
  XOfficeSpreadsheet = "x-office-spreadsheet",
  XOfficeSpreadsheetSymbolic = "x-office-spreadsheet-symbolic",
  XOfficeSpreadsheetTemplate = "x-office-spreadsheet-template",
  XPackageRepository = "x-package-repository",
  ZoomFitBest = "zoom-fit-best",
  ZoomIn = "zoom-in",
  ZoomOriginal = "zoom-original",
  ZoomOut = "zoom-out",
}
